import { getWindow } from 'ssr-window';

let browser;

function calcBrowser() {
  const window = getWindow();
  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') &gt;= 0 &amp;&amp; ua.indexOf('chrome') &lt; 0 &amp;&amp; ua.indexOf('android') &lt; 0;
  }
  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent),
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}

export { getBrowser };
